
(function loginDirectiveDefinition() {

    'use strict';

    /*
     * Esta directiva permite mostrar una pantalla de login al clickear en el elemento en que se coloca.
     */
    angular.module('Login')
        .directive('crLoginForm', [
            'login',
            function(login) {
                return {
                    restrict: 'E',
                    controller: 'LoginFormController',
                    templateUrl: login.templatesUrl + 'login-form.html',
                    scope: {
                        onLogin: '&',
                        useRegister: '=?',
                        disableExternalLogin: '=?'
                    }
                };
            }
        ]);

})();